import React from "react";

import CommonPageComponents from "../../components/CommonComponents/CommonPageComponents";

const ComingSoon: React.FC = () => {
  return (
    <CommonPageComponents
      iconText="⏳"
      titleText="Coming Soon"
      msgText="We're working on something amazing. Stay tuned!"
      buttonText="Go Home"
      buttonLink="/"
    />
  );
};

export default ComingSoon;






